"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3278],{

/***/ 64344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ useDeleteGroupMutation; },
/* harmony export */   "EF": function() { return /* binding */ useGetGroupQuery; },
/* harmony export */   "Ky": function() { return /* binding */ useGetGroupsQuery; },
/* harmony export */   "mA": function() { return /* binding */ useUpdateGroupMutation; },
/* harmony export */   "mm": function() { return /* binding */ useCreateGroupMutation; }
/* harmony export */ });
/* unused harmony exports groupService, createGroups, deleteGroups, getGroups, updateGroups */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10092);
/* harmony import */ var common_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24125);
/* harmony import */ var common_transformPagination__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50135);





var groupService = common_service__WEBPACK_IMPORTED_MODULE_0__/* .service.enhanceEndpoints */ .Xn.enhanceEndpoints({
    addTagTypes: [
        "Group"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            createGroup: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "Group"
                    }
                ],
                query: function(query) {
                    return {
                        body: query,
                        method: "POST",
                        url: "partners/groups/"
                    };
                }
            }),
            deleteGroup: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "Group"
                    }
                ],
                query: function(query) {
                    return {
                        body: query,
                        method: "DELETE",
                        url: "partners/groups/".concat(query.id)
                    };
                }
            }),
            getGroup: builder.query({
                providesTags: function(req, _, res) {
                    return [
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "Group"
                        }
                    ];
                },
                query: function(query) {
                    return {
                        url: "partners/groups/".concat(query.id)
                    };
                }
            }),
            getGroups: builder.query({
                providesTags: [
                    {
                        id: "LIST",
                        type: "Group"
                    }
                ],
                query: function() {
                    return {
                        url: "partners/groups/?page_size=1000"
                    };
                },
                transformResponse: function(res, _, req) {
                    return (0,common_transformPagination__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(req, res);
                }
            }),
            updateGroup: builder.mutation({
                invalidatesTags: function(req, _, res) {
                    return [
                        {
                            id: "LIST",
                            type: "Group"
                        },
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "Group"
                        }, 
                    ];
                },
                queryFn: function queryFn(arg, _queryApi, _extraOptions, baseQuery) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                        var toAdd, toRemove, toUpdate, users, rest, updateResult;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    toAdd = arg.toAdd, toRemove = arg.toRemove, toUpdate = arg.toUpdate, users = arg.users, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(arg, [
                                        "toAdd",
                                        "toRemove",
                                        "toUpdate",
                                        "users"
                                    ]);
                                    return [
                                        4,
                                        Promise.all((toRemove || []).map(function(v) {
                                            baseQuery({
                                                body: {},
                                                method: "DELETE",
                                                url: "partners/groups/".concat(rest.id, "/members/").concat(v.id)
                                            });
                                        }))
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        4,
                                        Promise.all((toUpdate || []).map(function(v) {
                                            baseQuery({
                                                body: v,
                                                method: "PUT",
                                                url: "partners/groups/".concat(rest.id, "/members/").concat(v.id)
                                            });
                                        }))
                                    ];
                                case 2:
                                    _state.sent();
                                    if (toAdd === null || toAdd === void 0 ? void 0 : toAdd.length) {
                                        baseQuery({
                                            body: {
                                                users: toAdd.map(function(v) {
                                                    return {
                                                        role: v.role,
                                                        user_id: v.user_id
                                                    };
                                                })
                                            },
                                            method: "POST",
                                            url: "/partners/groups/".concat(rest.id, "/members")
                                        });
                                    }
                                    return [
                                        4,
                                        baseQuery({
                                            body: rest,
                                            method: "PUT",
                                            url: "partners/groups/".concat(rest.id)
                                        })
                                    ];
                                case 3:
                                    updateResult = _state.sent();
                                    return [
                                        2,
                                        updateResult
                                    ];
                            }
                        });
                    })();
                }
            })
        };
    }
});
function createGroups(store, data, options) {
    return _createGroups.apply(this, arguments);
}
function _createGroups() {
    _createGroups = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(groupService.endpoints.createGroup.initiate(data, options))
            ];
        });
    });
    return _createGroups.apply(this, arguments);
}
function deleteGroups(store, data, options) {
    return _deleteGroups.apply(this, arguments);
}
function _deleteGroups() {
    _deleteGroups = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(groupService.endpoints.deleteGroup.initiate(data, options))
            ];
        });
    });
    return _deleteGroups.apply(this, arguments);
}
function getGroups(store, data, options) {
    return _getGroups.apply(this, arguments);
}
function _getGroups() {
    _getGroups = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(groupService.endpoints.getGroups.initiate(data, options))
            ];
        });
    });
    return _getGroups.apply(this, arguments);
}
function updateGroups(store, data, options) {
    return _updateGroups.apply(this, arguments);
}
function _updateGroups() {
    _updateGroups = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(groupService.endpoints.updateGroup.initiate(data, options))
            ];
        });
    });
    return _updateGroups.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useCreateGroupMutation = groupService.useCreateGroupMutation, useDeleteGroupMutation = groupService.useDeleteGroupMutation, useGetGroupQuery = groupService.useGetGroupQuery, useGetGroupsQuery = groupService.useGetGroupsQuery, useUpdateGroupMutation = groupService.useUpdateGroupMutation;


/***/ }),

/***/ 76527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LL": function() { return /* binding */ useGetTeamMembersQuery; },
/* harmony export */   "NM": function() { return /* binding */ useUpdateTeamMemberMutation; },
/* harmony export */   "yp": function() { return /* binding */ useCreateTeamMemberMutation; }
/* harmony export */ });
/* unused harmony exports teamMemberService, getTeamMembers, createTeamMember, deleteTeamMember, getTeamMember, updateTeamMember, useDeleteTeamMemberMutation, useGetTeamMemberQuery */
/* harmony import */ var common_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24125);
/* harmony import */ var common_transformPagination__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50135);
/* harmony import */ var common_utils_urls_param__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57384);





var teamMemberService = common_service__WEBPACK_IMPORTED_MODULE_0__/* .service.enhanceEndpoints */ .Xn.enhanceEndpoints({
    addTagTypes: [
        "TeamMember"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            createTeamMember: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "TeamMember"
                    }
                ],
                query: function(query) {
                    return {
                        body: query,
                        method: "POST",
                        url: "partners/users"
                    };
                }
            }),
            deleteTeamMember: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "TeamMember"
                    }
                ],
                query: function(query) {
                    return {
                        body: query,
                        method: "DELETE",
                        url: "partners/users/".concat(query.id)
                    };
                }
            }),
            getTeamMember: builder.query({
                providesTags: function(res) {
                    return [
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "TeamMember"
                        }
                    ];
                },
                query: function(query) {
                    return {
                        url: "partners/users/".concat(query.id)
                    };
                }
            }),
            getTeamMembers: builder.query({
                providesTags: [
                    {
                        id: "LIST",
                        type: "TeamMember"
                    }
                ],
                query: function(query) {
                    return {
                        url: "partners/users?".concat((0,common_utils_urls_param__WEBPACK_IMPORTED_MODULE_1__/* .toParam */ .i)(query))
                    };
                },
                transformResponse: function(res, _, req) {
                    return (0,common_transformPagination__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(req, res);
                }
            }),
            updateTeamMember: builder.mutation({
                invalidatesTags: function(res) {
                    return [
                        {
                            id: "LIST",
                            type: "TeamMember"
                        },
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "TeamMember"
                        }, 
                    ];
                },
                query: function(query) {
                    return {
                        body: query,
                        method: "PUT",
                        url: "partners/users/".concat(query.id)
                    };
                }
            })
        };
    }
});
function getTeamMembers(store, data, options) {
    return _getTeamMembers.apply(this, arguments);
}
function _getTeamMembers() {
    _getTeamMembers = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(teamMemberService.endpoints.getTeamMembers.initiate(data, options))
            ];
        });
    });
    return _getTeamMembers.apply(this, arguments);
}
function createTeamMember(store, data, options) {
    return _createTeamMember.apply(this, arguments);
}
function _createTeamMember() {
    _createTeamMember = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(teamMemberService.endpoints.createTeamMember.initiate(data, options))
            ];
        });
    });
    return _createTeamMember.apply(this, arguments);
}
function deleteTeamMember(store, data, options) {
    return _deleteTeamMember.apply(this, arguments);
}
function _deleteTeamMember() {
    _deleteTeamMember = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(teamMemberService.endpoints.deleteTeamMember.initiate(data, options))
            ];
        });
    });
    return _deleteTeamMember.apply(this, arguments);
}
function getTeamMember(store, data, options) {
    return _getTeamMember.apply(this, arguments);
}
function _getTeamMember() {
    _getTeamMember = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(teamMemberService.endpoints.getTeamMember.initiate(data, options))
            ];
        });
    });
    return _getTeamMember.apply(this, arguments);
}
function updateTeamMember(store, data, options) {
    return _updateTeamMember.apply(this, arguments);
}
function _updateTeamMember() {
    _updateTeamMember = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(teamMemberService.endpoints.updateTeamMember.initiate(data, options))
            ];
        });
    });
    return _updateTeamMember.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useCreateTeamMemberMutation = teamMemberService /* Usage examples:
const { data, isLoading } = useGetTeamMembersQuery({ id: 2 }, {}) //get hook
const [createTeamMembers, { isLoading, data, isSuccess }] = useCreateTeamMembersMutation() //create hook
teamMemberService.endpoints.getTeamMembers.select({id: 2})(store.getState()) //access data from any function
*/ .useCreateTeamMemberMutation, useDeleteTeamMemberMutation = teamMemberService.useDeleteTeamMemberMutation, useGetTeamMemberQuery = teamMemberService.useGetTeamMemberQuery, useGetTeamMembersQuery = teamMemberService.useGetTeamMembersQuery, useUpdateTeamMemberMutation = teamMemberService.useUpdateTeamMemberMutation;


/***/ }),

/***/ 12922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ preventDefault; }
/* harmony export */ });
function preventDefault(e) {
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    if (e && e.preventDefault) {
        e.preventDefault();
    }
}


/***/ }),

/***/ 95894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ safeParseEventValue; }
/* harmony export */ });
function safeParseEventValue(e) {
    // safe attempt to parse form value
    if (!e) {
        return e;
    }
    if (!e.target) {
        return e;
    }
    var target = e.target;
    if (target.getAttribute) {
        return target.getAttribute("type") === "checkbox" || target.getAttribute("type") === "radio" ? target.getAttribute("checked") : typeof target.value === "string" ? target.value : target.getAttribute("data-value") || target.getAttribute("value");
    }
    if (target && target.textContent) {
        return e.target.textContent;
    }
    return target ? target.value : e;
}


/***/ }),

/***/ 81194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BB": function() { return /* binding */ openConfirm; }
});

// UNUSED EXPORTS: Modal, ModalBody, ModalFooter, ModalHeader, openAlert, openModal

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/reactstrap/dist/reactstrap.modern.js
var reactstrap_modern = __webpack_require__(50450);
// EXTERNAL MODULE: ./components/base/forms/Button.tsx
var Button = __webpack_require__(41280);
// EXTERNAL MODULE: ./components/base/forms/Input.tsx + 1 modules
var Input = __webpack_require__(4386);
// EXTERNAL MODULE: ./common/utils/forms/safeEventParseValue.ts
var safeEventParseValue = __webpack_require__(95894);
// EXTERNAL MODULE: ./common/utils/string/GUID.ts
var GUID = __webpack_require__(93654);
;// CONCATENATED MODULE: ./components/base/ModalConfirm.tsx









var Confirm = function(param) {
    var challenge = param.challenge, children = param.children, disabled = param.disabled, disabledYes = param.disabledYes, isDanger = param.isDanger, isOpen = param.isOpen, _noText = param.noText, noText = _noText === void 0 ? "Cancel" : _noText, onNo = param.onNo, onYes = param.onYes, title = param.title, toggle = param.toggle, _yesText = param.yesText, yesText = _yesText === void 0 ? "OK" : _yesText;
    var id = (0,compat_module.useRef)((0,GUID/* GUID */.x)());
    (0,compat_module.useEffect)(function() {
        if (challenge) {
            var ref;
            (ref = document.getElementById(id.current)) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        challenge
    ]);
    var no = function() {
        return onNo ? onNo(toggle) : toggle === null || toggle === void 0 ? void 0 : toggle();
    };
    var yes = function() {
        return onYes ? onYes(toggle) : toggle === null || toggle === void 0 ? void 0 : toggle();
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,compat_module.useState)(""), 2), challengeAnswer = ref[0], setChallengeAnswer = ref[1];
    var invalidateChallenge = !!challenge && challenge !== challengeAnswer;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(reactstrap_modern/* Modal */.u_, {
        unmountOnClose: true,
        isOpen: isOpen,
        toggle: no,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reactstrap_modern/* ModalHeader */.xB, {
                toggle: no,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(reactstrap_modern/* ModalBody */.fe, {
                children: [
                    children,
                    challenge && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Input/* default */.Z, {
                        id: id.current,
                        onKeyPress: function(e) {
                            if (e.key === "Enter" && challengeAnswer === challenge) {
                                yes();
                            }
                        },
                        className: "mt-2",
                        value: challengeAnswer,
                        onChange: function(e) {
                            return setChallengeAnswer((0,safeEventParseValue/* safeParseEventValue */.Q)(e));
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(reactstrap_modern/* ModalFooter */.mz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* Button */.zx, {
                        style: {
                            width: 90
                        },
                        theme: "secondary",
                        "data-test": "confirm-no",
                        disabled: disabled,
                        onClick: no,
                        children: noText
                    }),
                    isDanger ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* Button */.zx, {
                        style: {
                            width: 90
                        },
                        theme: "danger",
                        "data-test": "confirm-yes",
                        disabled: disabled || disabledYes || invalidateChallenge,
                        iconRight: "fas fa-trash",
                        onClick: yes,
                        children: yesText
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* Button */.zx, {
                        style: {
                            width: 90
                        },
                        "data-test": "confirm-yes",
                        disabled: disabled || disabledYes || invalidateChallenge,
                        onClick: yes,
                        children: yesText
                    }),
                    " "
                ]
            })
        ]
    });
};
/* harmony default export */ var ModalConfirm = (Confirm);

// EXTERNAL MODULE: ./components/base/ModalDefault.tsx
var ModalDefault = __webpack_require__(17977);
;// CONCATENATED MODULE: ./components/base/ModalAlert.tsx



var ModalAlert = function(param) {
    var children = param.children, isOpen = param.isOpen, _okText = param.okText, okText = _okText === void 0 ? "ok" : _okText, onDismiss = param.onDismiss, title = param.title, toggle = param.toggle;
    var onDissmissClick = function() {
        if (onDismiss) {
            onDismiss();
        }
        toggle === null || toggle === void 0 ? void 0 : toggle();
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(reactstrap_modern/* Modal */.u_, {
        unmountOnClose: true,
        isOpen: isOpen,
        toggle: onDissmissClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reactstrap_modern/* ModalHeader */.xB, {
                toggle: onDissmissClick,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reactstrap_modern/* ModalBody */.fe, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reactstrap_modern/* ModalFooter */.mz, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* Button */.zx, {
                    onClick: onDissmissClick,
                    children: okText
                })
            })
        ]
    });
};
ModalAlert.displayName = "ModalAlert";
/* harmony default export */ var base_ModalAlert = (ModalAlert);

// EXTERNAL MODULE: ./common/store.ts + 3 modules
var store = __webpack_require__(71185);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
;// CONCATENATED MODULE: ./components/base/Modal.tsx











var ModalHeader = (/* unused pure expression or super */ null && (_ModalHeader));
var ModalFooter = (/* unused pure expression or super */ null && (_ModalFooter));
var Modal = (/* unused pure expression or super */ null && (_Modal));
var ModalBody = (/* unused pure expression or super */ null && (_ModalBody));
var withModal = function(WrappedComponent) {
    return function(props) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref = (0,compat_module.useState)(true), isOpen = ref[0], setIsOpen = ref[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var toggle = (0,compat_module.useCallback)(function() {
            return setIsOpen(false);
        }, [
            setIsOpen
        ]);
        __webpack_require__.g.closeModal = toggle;
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(es/* Provider */.zt, {
            store: (0,store/* getStore */.b)(),
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(WrappedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                toggle: toggle
            }, props), {
                isOpen: isOpen
            }))
        });
    };
};
var _Confirm = withModal(ModalConfirm);
var _Alert = withModal(base_ModalAlert);
var _ModalDefault = withModal(ModalDefault/* default */.Z);
var openAlert = __webpack_require__.g.openAlert = function(title, children, onDismiss) {
    document.getElementById("alert") && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0,compat_module.unmountComponentAtNode)(document.getElementById("alert"));
    (0,compat_module.render)(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(_Alert, {
        title: title,
        onDismiss: onDismiss,
        children: children
    }), document.getElementById("alert"));
};
var openConfirm = function(title, body, onYes, onNo, yesText, noText) {
    document.getElementById("confirm") && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0,compat_module.unmountComponentAtNode)(document.getElementById("confirm"));
    (0,compat_module.render)(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(_Confirm, {
        yesText: yesText,
        noText: noText,
        isOpen: true,
        onNo: onNo,
        onYes: onYes,
        title: title,
        children: body
    }), document.getElementById("confirm"));
};
var openModal = __webpack_require__.g.openModal = function(title, body) {
    document.getElementById("modal") && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0,compat_module.unmountComponentAtNode)(document.getElementById("modal"));
    (0,compat_module.render)(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(_ModalDefault, {
        isOpen: true,
        title: title,
        children: body
    }), document.getElementById("modal"));
};


/***/ }),

/***/ 17977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50450);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);





var ModalDefault = function(param) {
    var children = param.children, className = param.className, isOpen = param.isOpen, modalClassName = param.modalClassName, onBeforeClose = param.onBeforeClose, onDismiss = param.onDismiss, _preventDismiss = param.preventDismiss, preventDismiss = _preventDismiss === void 0 ? false : _preventDismiss, sideModal = param.sideModal, size = param.size, title = param.title, toggle = param.toggle;
    var handleToggle = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var shouldClose, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (preventDismiss) return [
                        2
                    ];
                    if (!onBeforeClose) return [
                        3,
                        5
                    ];
                    shouldClose = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        onBeforeClose()
                    ];
                case 2:
                    shouldClose = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.error("onBeforeClose threw:", err);
                    shouldClose = false;
                    return [
                        3,
                        4
                    ];
                case 4:
                    if (!shouldClose) return [
                        2
                    ];
                    _state.label = 5;
                case 5:
                    onDismiss();
                    toggle();
                    return [
                        2
                    ];
            }
        });
    }), [
        preventDismiss,
        onBeforeClose,
        onDismiss,
        toggle
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(reactstrap__WEBPACK_IMPORTED_MODULE_4__/* .Modal */ .u_, {
        isOpen: isOpen,
        size: size,
        unmountOnClose: true,
        backdrop: preventDismiss ? "static" : true,
        keyboard: !preventDismiss,
        modalClassName: sideModal ? "side-modal" : modalClassName,
        toggle: handleToggle,
        children: [
            !!title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(reactstrap__WEBPACK_IMPORTED_MODULE_4__/* .ModalHeader */ .xB, {
                toggle: !preventDismiss ? handleToggle : undefined,
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(reactstrap__WEBPACK_IMPORTED_MODULE_4__/* .ModalBody */ .fe, {
                className: className,
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalDefault);


/***/ }),

/***/ 98908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);





var SelectIcon = function(_param) {
    var className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("input-icon", className),
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 15.5C11.744 15.5 11.488 15.402 11.293 15.207L7.29301 11.207C6.90201 10.816 6.90201 10.184 7.29301 9.79301C7.68401 9.40201 8.31601 9.40201 8.70701 9.79301L12.012 13.098L15.305 9.91801C15.704 9.53501 16.335 9.54601 16.719 9.94301C17.103 10.34 17.092 10.974 16.695 11.357L12.695 15.219C12.5 15.407 12.25 15.5 12 15.5Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectIcon);


/***/ }),

/***/ 22299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var react_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24762);
/* harmony import */ var common_utils_string_GUID__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93654);




var Tooltip = function(param) {
    var children = param.children, content = param.content, place = param.place, showIcon = param.showIcon;
    var id = (0,common_utils_string_GUID__WEBPACK_IMPORTED_MODULE_3__/* .GUID */ .x)();
    if (!content) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
            children: children
        });
    }
    var icon = showIcon && children ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
        className: "ms-1 fa fa-info-circle",
        "data-for": id,
        "data-tip": true
    }) : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("span", {
                "data-for": id,
                "data-tip": true,
                children: [
                    children,
                    icon
                ]
            }),
            !children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                className: "fa fa-info-circle",
                "data-for": id,
                "data-tip": true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                html: true,
                className: "rounded",
                id: id,
                place: place || "top",
                type: "dark",
                effect: "solid",
                children: typeof content === "string" ? content : content
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tooltip);


/***/ }),

/***/ 91263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_base_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22299);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4386);
/* harmony import */ var project_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71113);







 // Ensure you import the correct path for Input
var InputGroup = function(param) {
    var action = param.action, className = param.className, component = param.component, defaultValue = param.defaultValue, disabled = param.disabled, error = param.error, errorMessage = param.errorMessage, providedId = param.id, _inputProps = param.inputProps, inputProps = _inputProps === void 0 ? {} : _inputProps, inputRef = param.inputRef, isValid = param.isValid, name = param.name, onBlur = param.onBlur, onChange = param.onChange, placeholder = param.placeholder, required = param.required, textarea = param.textarea, title = param.title, tooltip = param.tooltip, touched = param.touched, _type = param.type, type = _type === void 0 ? "text" : _type, value = param.value;
    var id = providedId || name || inputProps.id || inputProps.name;
    // Compute conditional isValid and errorMessage based on touched and error
    var computedIsValid = isValid !== undefined ? isValid : touched && error ? false : undefined;
    var computedErrorMessage = errorMessage !== undefined ? errorMessage : touched && error ? error : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("form-group", className),
        children: [
            (title || action) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: "flex-row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(components_base_Tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    place: "top",
                    content: tooltip,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("label", {
                            className: "form-label d-flex align-items-center fw-semibold flex-fill",
                            htmlFor: id,
                            children: [
                                title,
                                tooltip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(project_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    width: 18,
                                    fill: "dark300",
                                    name: "info",
                                    className: "mx-2 text-dark300"
                                }),
                                required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                    className: "text-danger",
                                    children: "*"
                                })
                            ]
                        }),
                        action
                    ]
                })
            }),
            component ? component : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                name: name,
                touched: touched,
                textarea: textarea,
                inputRef: inputRef,
                onBlur: onBlur
            }, inputProps), {
                isValid: computedIsValid,
                disabled: disabled,
                value: value,
                "data-test": [
                    "data-test"
                ],
                defaultValue: defaultValue,
                onChange: onChange,
                type: type || "text",
                id: id,
                placeholder: placeholder
            })),
            computedErrorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                id: inputProps.name ? "".concat(inputProps.name, "-error") : "",
                className: "text-danger",
                children: computedErrorMessage
            })
        ]
    });
};
InputGroup.displayName = "InputGroup";
/* harmony default export */ __webpack_exports__["Z"] = (InputGroup);


/***/ }),

/***/ 68046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SelectComponents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24969);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82569);
/* harmony import */ var components_base_SelectIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98908);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);








var Control = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_select__WEBPACK_IMPORTED_MODULE_5__.c.Control, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: "select-form-control"
    }, props), {
        children: children
    }));
};
var SelectComponents = {
    Control: Control,
    DropdownIndicator: components_base_SelectIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
};
var Select = function(_param) {
    var isValid = _param.isValid, _shouldValidate = _param.shouldValidate, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "isValid",
        "shouldValidate"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), shouldValidate = ref[0], setShouldValidate = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (_shouldValidate) {
            setShouldValidate(true);
        }
    }, [
        _shouldValidate
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("position-relative input-container", rest.className, {
            invalid: isValid === false && !!shouldValidate
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_select__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            onBlur: function() {
                setShouldValidate(true);
            },
            components: SelectComponents
        }, rest), {
            classNamePrefix: "select",
            className: "select"
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 80905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var rc_switch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52143);








var Checkbox = function(_param) {
    var checked = _param.checked, className = _param.className, id = _param.id, label = _param.label, onChange = _param.onChange, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "checked",
        "className",
        "id",
        "label",
        "onChange"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("lh-input d-flex align-items-center", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(rc_switch__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
                id: id,
                checked: checked,
                onChange: function(e) {
                    var ref1;
                    (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.blur();
                    onChange(e);
                }
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("label", {
                onClick: function() {
                    var ref1;
                    (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.blur();
                    onChange(!checked);
                },
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("ms-2 cursor-pointer fw-semibold user-select-none form-check-label", {
                    disabled: rest.disabled
                }),
                htmlFor: id,
                children: label
            })
        ]
    });
};
Checkbox.displayName = "Checkbox";
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 63278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ project_CreateEditGroup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./components/base/forms/InputGroup.tsx
var InputGroup = __webpack_require__(91263);
// EXTERNAL MODULE: ./components/base/forms/Button.tsx
var Button = __webpack_require__(41280);
// EXTERNAL MODULE: ./components/base/Toast.tsx
var Toast = __webpack_require__(12198);
// EXTERNAL MODULE: ./components/base/Messages.tsx + 1 modules
var Messages = __webpack_require__(56884);
// EXTERNAL MODULE: ./common/utils/forms/preventDefault.ts
var preventDefault = __webpack_require__(12922);
// EXTERNAL MODULE: ./common/services/useGroup.ts
var useGroup = __webpack_require__(64344);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./project/Icon.tsx
var Icon = __webpack_require__(71113);
// EXTERNAL MODULE: ./components/base/Loader.tsx
var Loader = __webpack_require__(1986);
// EXTERNAL MODULE: ./components/base/forms/Switch.tsx
var Switch = __webpack_require__(80905);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-baa8dc4f.esm.js + 4 modules
var index_baa8dc4f_esm = __webpack_require__(24969);
// EXTERNAL MODULE: ./components/base/Modal.tsx + 2 modules
var Modal = __webpack_require__(81194);
// EXTERNAL MODULE: ./components/base/forms/Checkbox.tsx
var Checkbox = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/base/forms/Select.tsx
var Select = __webpack_require__(68046);
// EXTERNAL MODULE: ./common/services/useTeamMember.ts
var useTeamMember = __webpack_require__(76527);
;// CONCATENATED MODULE: ./components/AddRemoveMembers.tsx















var AddRemoveMembers = function(param) {
    var groupMembers = param.groupMembers, setGroupMembers = param.setGroupMembers;
    var ref = (0,useTeamMember/* useGetTeamMembersQuery */.LL)({
        page_size: 100
    }), data = ref.data, error = ref.error, isFetching = ref.isFetching;
    var teamMembers = data === null || data === void 0 ? void 0 : data.results;
    var handleMemberAdd = function(v) {
        var newMember = v.value;
        if (!newMember || groupMembers.some(function(m) {
            return m.user_id === newMember.id;
        })) return;
        setGroupMembers((0,_to_consumable_array/* default */.Z)(groupMembers).concat([
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newMember), {
                role: groupMembers.length === 0 ? "OWNER" : "MEMBER"
            }), 
        ]));
    };
    var handleRoleChange = function(memberId, checked) {
        if (!checked) {
            var ownerCount = groupMembers.filter(function(m) {
                return m.role === "OWNER";
            }).length;
            if (ownerCount <= 1) {
                return;
            }
        }
        setGroupMembers(groupMembers.map(function(u) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, u), {
                role: u.id === memberId ? checked ? "OWNER" : "MEMBER" : "MEMBER"
            });
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
        children: data ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InputGroup/* default */.Z, {
                    title: "Add a Team Member",
                    component: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Select/* default */.Z, {
                        components: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Select/* SelectComponents */.r), {
                            Option: function(props) {
                                var ref = props.value || {}, first_name = ref.first_name, id = ref.id, last_name = ref.last_name;
                                var isMember = groupMembers.find(function(v) {
                                    return v.user_id === id;
                                });
                                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_baa8dc4f_esm.c.Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                            className: "d-flex justify-content-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                    className: "fw-semibold",
                                                    children: "".concat(first_name, " ").concat(last_name)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Checkbox/* default */.Z, {
                                                    label: "",
                                                    checked: !!isMember,
                                                    id: id
                                                })
                                            ]
                                        })
                                    })
                                }));
                            }
                        }),
                        closeMenuOnSelect: false,
                        hideSelectedOptions: false,
                        value: [],
                        onChange: handleMemberAdd,
                        options: teamMembers === null || teamMembers === void 0 ? void 0 : teamMembers.map(function(v) {
                            return {
                                value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, v), {
                                    user_id: v.id
                                })
                            };
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "mt-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "fw-semibold fs-lg d-block mb-4",
                            children: "Team Members"
                        }),
                        !(groupMembers === null || groupMembers === void 0 ? void 0 : groupMembers.length) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "text-muted",
                            children: "No team members"
                        }),
                        groupMembers.map(function(v) {
                            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "d-flex justify-content-between bg-light150 px-4 py-2 rounded mb-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                        className: "d-flex flex-column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                                                className: "fw-semibold",
                                                children: [
                                                    v.first_name,
                                                    " ",
                                                    v.last_name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                children: v.email
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                        className: "d-flex align-items-center gap-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                        className: "fs-xss text-muted",
                                                        children: "Group Owner"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Switch/* default */.Z, {
                                                        checked: v.role === "OWNER",
                                                        onChange: function(checked) {
                                                            return handleRoleChange(v.id, checked);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon/* default */.Z, {
                                                className: classnames_default()({
                                                    "cursor-pointer": v.role !== "OWNER",
                                                    "opacity-50": v.role === "OWNER"
                                                }),
                                                name: "delete",
                                                fill: "danger",
                                                onClick: function() {
                                                    if (v.role === "OWNER" && groupMembers.filter(function(m) {
                                                        return m.role === "OWNER";
                                                    }).length <= 1) {
                                                        return;
                                                    }
                                                    (0,Modal/* openConfirm */.BB)("Confirm remove user", "Are you sure you wish to remove this user?", function(close) {
                                                        close();
                                                        setGroupMembers(groupMembers.filter(function(u) {
                                                            return v.id !== u.id;
                                                        }));
                                                    });
                                                }
                                            })
                                        ]
                                    })
                                ]
                            });
                        })
                    ]
                })
            ]
        }) : isFetching ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            className: "text-center",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Loader/* default */.Z, {})
        }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            className: "text-center",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Messages/* ErrorMessage */.Bc, {
                children: error
            })
        })
    });
};
/* harmony default export */ var components_AddRemoveMembers = (AddRemoveMembers);

;// CONCATENATED MODULE: ./components/project/CreateEditGroup.tsx













var defaultGroup = {
    name: "",
    users: []
};
var CreateEditGroup = function(param) {
    var group = param.group, onCancel = param.onCancel, onComplete = param.onComplete;
    var isEdit = !!group;
    var ref = (0,compat_module.useState)(group || defaultGroup), data = ref[0], setData = ref[1];
    (0,compat_module.useEffect)(function() {
        var ref;
        (ref = document.getElementById("name")) === null || ref === void 0 ? void 0 : ref.focus();
    }, []);
    var handleChange = function(field, value) {
        setData(function(prevData) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), (0,_define_property/* default */.Z)({}, field, value));
        });
    };
    var isValid = !!data.name;
    var ref1 = (0,compat_module.useMemo)(function() {
        var toRemove = ((group === null || group === void 0 ? void 0 : group.users) || []).filter(function(v) {
            var ref;
            return !(data === null || data === void 0 ? void 0 : (ref = data.users) === null || ref === void 0 ? void 0 : ref.find(function(u) {
                return v.user_id === u.user_id;
            }));
        });
        var toAdd = data === null || data === void 0 ? void 0 : data.users.filter(function(v) {
            var ref;
            return !(group === null || group === void 0 ? void 0 : (ref = group.users) === null || ref === void 0 ? void 0 : ref.find(function(u) {
                return v.user_id === u.user_id;
            }));
        });
        var toUpdate = data === null || data === void 0 ? void 0 : data.users.filter(function(v) {
            var ref;
            return group === null || group === void 0 ? void 0 : (ref = group.users) === null || ref === void 0 ? void 0 : ref.find(function(u) {
                return v.user_id === u.user_id;
            });
        });
        return {
            toAdd: toAdd,
            toRemove: toRemove,
            toUpdate: toUpdate
        };
    }, [
        group,
        data
    ]), toAdd = ref1.toAdd, toRemove = ref1.toRemove, toUpdate = ref1.toUpdate;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useGroup/* useCreateGroupMutation */.mm)({}), 2), createGroup = ref2[0], ref3 = ref2[1], createError = ref3.error, creating = ref3.isLoading;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useGroup/* useUpdateGroupMutation */.mA)({}), 2), updateGroup = ref4[0], ref5 = ref4[1], updateError = ref5.error, updating = ref5.isLoading;
    var isLoading = updating || creating;
    var error = createError || updateError;
    var save = function() {
        var func = isEdit ? updateGroup : createGroup;
        func((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            toAdd: toAdd,
            toRemove: toRemove,
            toUpdate: toUpdate,
            users: data.users
        })).then(function(res) {
            if (!("error" in res)) {
                (0,Toast/* toast */.Am)("Success", "".concat(group ? "Updated" : "Created", " group"));
                onComplete === null || onComplete === void 0 ? void 0 : onComplete(res.data);
            }
        });
    };
    var submit = function(e) {
        (0,preventDefault/* preventDefault */.P)(e);
        if (isValid) {
            save();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("form", {
        onSubmit: submit,
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "d-flex flex-column gap-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "d-flex justify-content-between gap-4 flex-nowrap",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "flex-fill",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InputGroup/* default */.Z, {
                            autoFocus: true,
                            title: "Group Name",
                            required: true,
                            id: "name",
                            isValid: !!data.name,
                            value: data.name,
                            onChange: function(e) {
                                return handleChange("name", e.target.value);
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_AddRemoveMembers, {
                    setGroupMembers: function(v) {
                        handleChange("users", v.map(function(v) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, v), {
                                user_id: v.user_id || v.id
                            });
                        }));
                    },
                    groupMembers: data.users
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Messages/* ErrorMessage */.Bc, {
                    children: error
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "d-flex justify-content-end gap-2",
                    children: [
                        onCancel && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                            style: {
                                width: 140
                            },
                            theme: "secondary",
                            onClick: onCancel,
                            type: "button",
                            disabled: isLoading,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                            style: {
                                width: 140
                            },
                            type: "submit",
                            disabled: !isValid || isLoading,
                            children: isEdit ? "Update Group" : "Create Group"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var project_CreateEditGroup = (CreateEditGroup);


/***/ })

}]);